// extracted by mini-css-extract-plugin
export default {"overlay":"mimic___style_overlay__I7E8S","dropdown":"mimic___style_dropdown__wGLYK"};